import { render, staticRenderFns } from "./ConsumptionsRoutesTable.vue?vue&type=template&id=57c0716b&"
import script from "./ConsumptionsRoutesTable.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsRoutesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports